module.exports = "https://www.gc-pro.gnp.com.mx/ed8682967e3184ab319025efd4da11f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/boton/03.png
// module id = 1008
// module chunks = 0 1